import { css } from 'styled-components';
import { media, rem } from '../../../helpers/mixins';
import {
  WHITE, GRADIENT_GREEN, GRADIENT_PINK, GRADIENT_YELLOW, PINK, PINK_BACKGROUND, PURPLE_LIGHT, PURPLE_DARK, PURPLE_BACKGROUND, PURPLE_LIGHTER, PURPLE_NEON
} from '../../../constants/colors';

/**
 * Helper thar returns the gradient color option
 * @param {string} color - gradient color
 * @returns {string}
 */
export const getGradientColor = (color) => {
  switch (color) {
    case 'pink':
      return `linear-gradient(${GRADIENT_PINK})`;
    case 'yellow':
      return `linear-gradient(${GRADIENT_YELLOW})`;
    case 'green':
    default:
      return `linear-gradient(${GRADIENT_GREEN})`;
  }
};

export default {
  more: css`
    z-index: 5;
    position: absolute;
    bottom: 32px;
    right: 32px;
    width: 16px;
    height:16px;
    max-width:16px;
  `,
  description: css`
    color: ${PURPLE_LIGHT};
    font-size: ${rem('16px')};
    line-height: ${rem('20px')};
    margin-bottom: 20px;
    position: relative;
    z-index: 5;
  `,
  title: css`
    color: #3F2B56;
    font-size: ${rem('20px')};
    line-height: ${rem('24px')};
    position: relative;
    z-index: 5;
    text-align:center;
    width:100%;
  `,
  container: css`
    position: relative;
    overflow: hidden;
    width: 90%;
    border-radius:18px;
    box-shadow: 0px 0px 3px 3px rgba(125, 125, 125, .40);
    background-color: ${WHITE};
    margin: 36px auto;
    padding: 0;
    ${media.sm`
      border-radius: 18px;
      background-size: cover;
    `};
    background-color: #F9AA23;
  `,

  innerwrapper: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    background-color: rgb(230,230,230);
    height: 100px;
    padding: 1em 2em;
  `,
  imageWrapper: css`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    height: 250px;
    width:100%;
    background-color: white;
    fit-content: cover;
    object-fit: cover;
  `,
  gradientLayer: ({ gradientColor }) => css`
    position: absolute;
    width: 100%;
    height: 100%;
    background: ${getGradientColor(gradientColor)};
    background-color: rgba(0,0,0,0.4);
    bottom: 0px;
    ${media.sm`
       height: 85%;
       bottom: -5px;
       background-color: rgba(0,0,0,0.0);
    `};
    left: 0;
  `
};
